import { action, computed, toJS, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class Filtros {
    store;

    constructor(store) {
        makeObservable(this, {
            reset: action,
            filtros: computed,
            filtrosComFiltroRapido: computed,
            filtrosComValor: computed,
            existeFiltroCarregando: computed,
            existeFiltroComValor: computed,
            existeFiltroRapidoComValor: computed,
            existeFiltroRapidoComValorPadrao: computed,
            existeFiltroBooleanoComValor: computed,
            atualizarValores: action
        });

        this.store = store;
    }

    static posicaoFiltroRapido(idFiltro, ordemFiltroRapido) {
        if (!this.validarArrayOrdemFiltroRapido(ordemFiltroRapido)) {
            console.warn('Verifique elementos repetidos no array de ordem dos filtros rápidos!');
        }

        const posicao = ordemFiltroRapido?.indexOf(idFiltro);

        if (posicao === undefined || posicao === -1) {
            console.warn(`Atenção: posição do filtro rápido "${idFiltro}" não definida!`);
            return 99;
        }

        return posicao + 1;
    }

    static validarArrayOrdemFiltroRapido(ordemFiltroRapido) {
        return ordemFiltroRapido && new Set(ordemFiltroRapido).size === ordemFiltroRapido.length;
    }

    reset() {
        this.filtros.forEach((filtro) => (filtro.valor = undefined));
    }

    get filtros() {
        let retorno = [];
        for (const key in this) {
            if (this[key] !== undefined && this[key] instanceof Filtro) {
                retorno.push(this[key]);
            }
        }
        return retorno;
    }

    get filtrosComFiltroRapido() {
        let retorno = [];
        for (const key in this) {
            if (this[key] !== undefined && this[key] instanceof Filtro && this[key].filtroRapido !== undefined) {
                retorno.push(this[key]);
            }
        }
        return retorno;
    }

    get filtrosComValor() {
        let retorno = [];
        for (const key in this) {
            if (this[key] !== undefined && this[key] instanceof Filtro && this.isFiltroComValor(this[key])) {
                retorno.push(this[key]);
            }
        }
        return retorno;
    }

    isFiltroComValor(filtro) {
        if (filtro.valor !== undefined) {
            if (Array.isArray(toJS(filtro.valor))) {
                return filtro.valor.slice().length > 0;
            }
            return true;
        }
        return false;
    }

    get existeFiltroCarregando() {
        for (const key in this) {
            if (this[key] !== undefined && this[key] instanceof Filtro && this[key].carregando) {
                return true;
            }
        }
        return false;
    }

    get existeFiltroComValor() {
        for (const key in this) {
            if (this[key] !== undefined && this[key] instanceof Filtro && this.isFiltroComValor(this[key])) {
                return true;
            }
        }
        return false;
    }

    get existeFiltroRapidoComValor() {
        for (const key in this) {
            if (
                this[key] !== undefined &&
                this[key] instanceof Filtro &&
                this[key].filtroRapido &&
                this.isFiltroComValor(this[key])
            ) {
                return true;
            }
        }
        return false;
    }

    get existeFiltroRapidoComValorPadrao() {
        for (const key in this) {
            if (
                this[key] !== undefined &&
                this[key] instanceof Filtro &&
                this[key].filtroRapido &&
                this.isFiltroComValor(this[key]) &&
                this.isValorFiltroRapidoSelecionado(this[key])
            ) {
                return true;
            }
        }
        return false;
    }

    isValorFiltroRapidoSelecionado(filtro) {
        return filtro.valor === filtro.filtroRapido.valor || this.isOpcaoSelecionada(filtro);
    }

    isValorArraySelecionado(filtro) {
        return Array.isArray(toJS(filtro.valor)) && filtro.valor.find((valor) => valor === filtro.valor);
    }

    isOpcaoSelecionada(filtro) {
        return filtro.filtroRapido.opcoes && filtro.filtroRapido.opcoes.find((opcao) => opcao.valor === filtro.valor);
    }

    get existeFiltroBooleanoComValor() {
        for (const key in this) {
            if (
                this[key] !== undefined &&
                this[key] instanceof Filtro &&
                this[key].tipo === 'booleano' &&
                this[key].valor !== undefined
            ) {
                return true;
            }
        }
        return false;
    }

    filtrarProcessos = (processos) => {
        this.filtrosComValor.forEach((filtro) => {
            processos = filtro.filtrar(processos);
        });
        return processos;
    };

    atualizarValores(filtros) {
        for (const key in filtros) {
            if (filtros[key] !== undefined && filtros[key] instanceof Filtro && filtros[key].idFiltro) {
                this[filtros[key].idFiltro].valor = filtros[key].valor;
            }
        }
    }

    labelBooleanoComSem = (booleano) => (booleano ? 'COM' : 'SEM');

    labelBooleanoSimNao = (booleano) => (booleano ? 'SIM' : 'NÃO');
}
